import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  person: {},
  rating: 0,
  cachedPerson: {},
  personByEmail: {},
  cachedPersonByEmail: {},
  persons: {},
  cachedPersons: {},
};

export default {
  actions,
  getters,
  mutations,
  state,
};
